<template>
  <div class="text-center">
    <h1>503 - {{ $t("maintenancepage.unavailable") }}</h1>
    <h2>{{ $t("maintenancepage.subtitle") }}</h2>
  </div>
</template>
<script>
export default {
  name: "MaintenanceView"
}
</script>
